// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"406":"3da9a9a6","892":"b90ebcbe"}[chunkId] + ".js";
};